const CHECKOUT_SELECTOR = 'button[name="checkout"]';

document.addEventListener('submit', (event) => {
  const feedbackStartedAt = performance.now();
  const form = event.target;

  if (!(form instanceof HTMLFormElement)) return;

  const submitter = event.submitter;

  if (submitter && !(submitter instanceof HTMLButtonElement && submitter.matches(CHECKOUT_SELECTOR))) return;

  const checkoutButton = submitter || form.querySelector(CHECKOUT_SELECTOR);

  if (!(checkoutButton instanceof HTMLButtonElement)) return;

  if (form.dataset.pbCheckoutSubmitting === 'true') {
    event.preventDefault();
    return;
  }

  form.dataset.pbCheckoutSubmitting = 'true';

  // Preserve Shopify's checkout intent after disabling the named submitter.
  const checkoutIntent = document.createElement('input');
  checkoutIntent.type = 'hidden';
  checkoutIntent.name = 'checkout';
  checkoutIntent.value = 'checkout';
  checkoutIntent.dataset.pbCheckoutIntent = 'true';
  form.append(checkoutIntent);

  checkoutButton.disabled = true;
  checkoutButton.setAttribute('aria-disabled', 'true');
  checkoutButton.setAttribute('aria-busy', 'true');
  checkoutButton.classList.add('pb-checkout-button--loading');
  checkoutButton.dataset.pbCheckoutOriginalHtml = checkoutButton.innerHTML;

  const label = checkoutButton.querySelector('[data-pb-checkout-label]');
  if (label) label.textContent = '購入手続きへ移動中…';

  const status = document.querySelector('#status-announcement');
  if (status) status.textContent = '購入手続きへ移動しています。しばらくお待ちください。';

  const feedbackLatencyMs = Math.round(performance.now() - feedbackStartedAt);

  if (typeof window.gtag === 'function') {
    window.gtag('event', 'pb_checkout_feedback_shown', {
      surface: form.closest('cart-drawer') ? 'cart_drawer' : 'cart_page',
      feedback_latency_ms: feedbackLatencyMs,
      transport_type: 'beacon',
    });
  }
});

window.addEventListener('pageshow', () => {
  document.querySelectorAll('form[data-pb-checkout-submitting="true"]').forEach((form) => {
    delete form.dataset.pbCheckoutSubmitting;
    form.querySelectorAll('[data-pb-checkout-intent]').forEach((input) => input.remove());

    const checkoutButton = form.querySelector(CHECKOUT_SELECTOR);
    if (!(checkoutButton instanceof HTMLButtonElement)) return;

    checkoutButton.disabled = false;
    checkoutButton.removeAttribute('aria-disabled');
    checkoutButton.removeAttribute('aria-busy');
    checkoutButton.classList.remove('pb-checkout-button--loading');

    if (checkoutButton.dataset.pbCheckoutOriginalHtml) {
      checkoutButton.innerHTML = checkoutButton.dataset.pbCheckoutOriginalHtml;
      delete checkoutButton.dataset.pbCheckoutOriginalHtml;
    }
  });
});
